export const GET_ONLINE_VALUATION_DETAIL = 'GET_ONLINE_VALUATION_DETAIL';
export const SET_ONLINE_VALUATION_DETAIL = 'SET_ONLINE_VALUATION_DETAIL';
export const GET_ONLINE_VALUATION_DETAIL_ERROR = 'GET_ONLINE_VALUATION_DETAIL_ERROR';

export const GET_CONVERT_ONLINE_VALUATION_TO_MA = 'GET_CONVERT_ONLINE_VALUATION_TO_MA';
export const SET_CONVERT_ONLINE_VALUATION_TO_MA = 'SET_CONVERT_ONLINE_VALUATION_TO_MA';
export const GET_CONVERT_ONLINE_VALUATION_TO_MA_ERROR = 'GET_CONVERT_ONLINE_VALUATION_TO_MA_ERROR';
